import { __require as e } from "../../../dompurify@3.3.1/bundled_deps/dompurify/dist/purify.cjs.js";
var r, u;
function f() {
  return u || (u = 1, r = self.DOMPurify || (self.DOMPurify = e().default || e())), r;
}
export {
  f as __require
};
